import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';
import { BouncingText, HeaderCollapse } from '../../Components';
import setting from './setting.json';

const Link = ({ children, to }) => (
  <div className="header-link">
    <RouterLink to={to}>{children}</RouterLink>
  </div>
);
const links = setting.links.map((link, i) => (
  <Link key={i} to={link.href}>
    {link.text}
  </Link>
));

const Header = props => (
  <div className={props.className}>
    <div className="container">
      <BouncingText
        text="Welcome ~"
        clickable
        hoverable
        delay={15}
        duration={230}
        className="my-name"
      />
      <div className="hor">{links}</div>
      <div className="ver">
        <HeaderCollapse dayTime={props.dayTime} linksConfig={setting.links} />
      </div>
    </div>
  </div>
);

const linkAnimation = keyframes`
  0%  { transform: scale(1); }
  30% { transform: scale(1.2); }
  60% { transform: scale(1); }
  100%{ transform: scale(1); }
`;

export default styled(Header)`
  z-index: 10;
  > .container {
    display: flex;
    justify-content: flex-end;
    padding-right: 5px;
  }
  .header-link {
    padding: 0px 20px;
    font-size: 1.3em;
    &:hover {
      animation: ${linkAnimation} 0.8s infinite;
    }
  }
  .my-name {
    font-size: 1.3em;
    padding: 0px 20px;
    flex-grow: 1;
    letter-spacing: 1px;
    color: ${({ dayTime }) => (dayTime === 'night' ? 'white' : 'black')};
    transition: color 1s;
  }
  .ver {
    display: none;
  }
  .hor {
    display: flex;
  }
  @media (max-width: 767px) {
    .my-name {
      font-size: 1em;
      padding: 0px 0px;
    }
  }
  @media (max-width: 980px) {
    .ver {
      display: block;
    }
    .hor {
      display: none;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Header/index.js